<template>
  <va-card :title="title">
    <div class="flex row xs12">
      <strong>{{this.timesheet.employee_name}}</strong>
    </div>
    <div class="flex row xs12">
      <timesheet-entries
        :mode="mode"
        :records="timesheet.records"
        :locked="timesheet.locked"
        @submitClickedInTimesheet="submitClickedInTimesheet"
        @saveClickedInTimesheet="saveClickedInTimesheet"
        @approveClickedInTimesheet="approveClickedInTimesheet"
        @rejectClickedInTimesheet="rejectClickedInTimesheet"
        @adjustClickedInTimesheet="adjustClickedInTimesheet"
        @processClickedInTimesheet="processClickedInTimesheet"
      />
    </div>
    <div class="flex row xs12">
      <timesheet-comments :entry="timesheet" />
    </div>
  </va-card>
</template>

<script>
import TimesheetEntries from './TimesheetEntries'
import TimesheetComments from './TimesheetComments'

export default {
  name: 'timesheet',
  props: {
    timesheet: Object,
    mode: String,
  },
  components: {
    TimesheetComments,
    TimesheetEntries,
  },
  methods: {
    saveClickedInTimesheet (days) {
      this.timesheet.days = days
      this.$emit('totalHourChanged', days)
      this.$emit('saveClicked', this.timesheet)
    },
    submitClickedInTimesheet (days) {
      this.timesheet.days = days
      this.$emit('totalHourChanged', days)
      this.$emit('submitClicked', this.timesheet)
    },
    approveClickedInTimesheet (days) {
      this.timesheet.days = days
      this.$emit('totalHourChanged', days)
      this.$emit('approveClicked', this.timesheet)
    },
    rejectClickedInTimesheet (days) {
      this.timesheet.days = days
      this.$emit('totalHourChanged', days)
      this.$emit('rejectClicked', this.timesheet)
    },
    adjustClickedInTimesheet (days) {
      this.timesheet.days = days
      this.$emit('totalHourChanged', days)
      this.$emit('adjustClicked', this.timesheet)
    },
    processClickedInTimesheet (days) {
      this.timesheet.days = days
      this.$emit('totalHourChanged', days)
      this.$emit('processClicked', this.timesheet)
    },
    getTitle (start, end) {
      var monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ]
      var startDate = new Date(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate(), 0, 0, 0, 0)
      var endDate = new Date(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate(), 0, 0, 0, 0)
      return this.pad(startDate.getDate()) + ' - ' + this.pad(endDate.getDate()) + ' ' + monthNames[startDate.getMonth()] + ', ' + this.pad(startDate.getFullYear())
    },
    dayOfWeek (dayNumber) {
      var days = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
      ]
      return days[dayNumber]
    },
    pad (n) {
      return n < 10 ? '0' + n : n
    },
  },
  computed: {
    title () {
      if (this.timesheet.records !== undefined) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        var records = this.timesheet.records.sort((a, b) => {
          if (a.sequence > b.sequence) {
            return 1
          } else if (a.sequence < b.sequence) {
            return -1
          } else {
            return 0
          }
        })
        var start = new Date(records[0].record_date)
        var end = new Date(records[records.length - 1].record_date)
        return "period '" + this.getTitle(start, end) + "'"
      }
      return 'Selected Timesheet'
    },
  },
}
</script>

<style lang="scss">
</style>
